export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6919.9a75ddd9.jpg";